import { useEffect, useMemo, useState } from 'react';
import { checkNameNull } from '@/pages/dashboard/components/LeftMenu/utils';
import { LANGUAGE_CN } from '@/pages/home/_config/config';
import { DASHBOARD_NAME_REGEX } from '@dbl/core/global';

// 菜单相关
export const useMenuHooks = (props: any) => {
  const {currentGame, menuList, locale, formatMessage} = props;
  const [selectMenu, setSelectMenu] = useState<string>('');
  // 菜单错误信息
  const [menuErr, setMenuErr] = useState<string>('');
  const { filterMenuList } = useFilterMenu({currentGame, menuList, locale});
  // 检测菜单是否选中
  const checkMenu: () => boolean = () => {
    // 目录名为空字符串的情况
    if (!selectMenu) {
      setMenuErr(formatMessage({id: 'dbl_menu_select_null'}));
      return false;
    }
    setMenuErr('');
    return true;
  };
  
  useEffect(() => {
    if (filterMenuList?.length === 1) {
      setSelectMenu(filterMenuList[0]?.value);
    }
  }, [filterMenuList]);

  return {
    selectMenu,
    setSelectMenu,
    menuErr,
    setMenuErr,
    formatMenuList: filterMenuList,
    checkMenu
  };
};

// 筛选menu
export const useFilterMenu = (props: any) => {
  const {currentGame, menuList, locale} = props;
  const filterMenuList = useMemo(() => {
    const nameKey = locale === LANGUAGE_CN ? 'name_cn' : 'name_en';
    // const { role_id: roleId = '' } = currentGame || {};
  
    // (menuList || []).filter((menu: any) => {
    // @ts-ignore
    // if((BUSINESS_TYPE_PERMISSION[roleId] === SYS_MANAGER)) {
    //   // 不允许添加到框架报表
    //   return menu?.business_type !== BUSINESS_TYPE_GAME
    // }
    // // @ts-ignore
    // return (BUSINESS_TYPE_PERMISSION[roleId] || BUSINESS_TYPE_PERMISSION.default).includes(menu?.business_type);
    // 应王婕要求，roleId相关权限逻辑删除，只过滤掉框架报表
    // 和后端确认后，最少会有my space的目录返回
    // 2023-12-25 新需求: sys admin支持报表可以发布到任意目录, 后端做权限判断, 前端删除原有的过滤条件
    // return menu?.business_type !== BUSINESS_TYPE_GAME
    // })
    
    
    return (menuList || []).map((menu: any) => {
      const value = menu.u_id;
      const text = menu[nameKey] || menu?.name_en;
      return {
        ...menu,
        value,
        text
      };
    });
  }, [locale, menuList, currentGame]);
  return {
    filterMenuList
  };
};

// 目录相关
export const useFolderHooks = (props: any) => {
  const {folderList, selectMenu, locale, formatMessage} = props;
  const [selectFolder, setSelectFolder] = useState<string>('');
  // 目录错误信息
  const [folderErr, setFolderErr] = useState<string>('');
  const formatFolderList = useMemo(() => {
    if (!selectMenu) {
      return [];
    }
    return (folderList || []).filter((folder: any) => folder.u_parent_id === selectMenu).map((folder: any) => {
      const nameKey = locale === LANGUAGE_CN ? 'name_cn' : 'name_en';
      const value = folder.u_id;
      const text = folder[nameKey] || folder?.name_en;
      return {
        ...folder,
        value,
        text
      };
    });
  }, [folderList, selectMenu, locale]);

  // menu 更改重置  folder选择
  useEffect(() => {
    setSelectFolder(formatFolderList?.length === 1 ? formatFolderList[0]?.value : '');
  }, [selectMenu]);

  // 检测目录是否选中
  const checkFolder: () => boolean = () => {
    // 目录名为空字符串的情况
    if (!selectFolder) {
      setFolderErr(formatMessage({id: 'dbl_menu_folder_select_null'}));
      return false;
    }
    setFolderErr('');
    return true;
  };

  return {
    selectFolder,
    setSelectFolder,
    folderErr,
    setFolderErr,
    formatFolderList,
    checkFolder
  };
};

// userlevel相关
export const useListUserLevel = (props: any) => {
  const {formatMessage, levelList} = props;
  const [selectedLevel, setSelectedLevel] = useState<string | undefined>();
  const [userLevelErr, setUserLevelErr] = useState<string>('');
  const userLevelList = useMemo(()=>{
    const options = [] as any;
    if(levelList){
      for (const key in levelList) {
        options.push({
          value: key,
          text: key,
          des: levelList[key]
        });
      }
    } 
    return options;
  },[levelList]);

  // 检测userlevel是否选中
  const checkUserLevel: () => boolean = () => {
    // 目录名为空字符串的情况
    if (!selectedLevel) {
      setUserLevelErr(formatMessage({id: 'dbl_menu_user_level_select_null'}));
      return false;
    }
    setUserLevelErr('');
    return true;
  };
  
  useEffect(() => {
    if (userLevelList?.length === 1) {
      setSelectedLevel(userLevelList[0]?.value);
    }
  }, [userLevelList]);
  
  return {
    userLevelList,
    selectedLevel,
    setSelectedLevel,
    userLevelErr,
    setUserLevelErr,
    checkUserLevel
  };
};

// 目录相关
export const useSubFolderHooks = (props: any) => {
  const {subFolderList, selectFolder, locale, formatMessage} = props;
  const [selectSubFolder, setSelectSubFolder] = useState<string>('');
  // 目录错误信息
  const [subFolderErr, setSubFolderErr] = useState<string>('');

  const formatSubFolderList = useMemo(() => {
    if (!selectFolder) {
      return [];
    }
    return (subFolderList || []).filter((folder: any) => folder.u_parent_id === selectFolder).map((folder: any) => {
      const nameKey = locale === LANGUAGE_CN ? 'name_cn' : 'name_en';
      const value = folder.u_id;
      const text = folder[nameKey] || folder?.name_en;
      return {
        ...folder,
        value,
        text
      };
    });
  }, [subFolderList, selectFolder, locale]);

  // folder 更改重置  subFolder选择
  useEffect(() => {
    setSelectSubFolder('');
  }, [selectFolder]);

  // 检测目录是否选中
  const checkSubFolder: () => boolean = () => {
    // 目录名为空字符串的情况
    if (!selectSubFolder) {
      setSubFolderErr(formatMessage({id: 'dbl_menu_subfolder_select_null'}));
      return false;
    }
    setSubFolderErr('');
    return true;
  };

  return {
    selectSubFolder,
    setSelectSubFolder,
    subFolderErr,
    setSubFolderErr,
    formatSubFolderList,
    checkSubFolder
  };
};

// 名字相关，中文名，英文名
export const useNameHooks = ( formatMessage: any,dashboardName:string,type:string) => {

  const [nameCN, setNameCN] = useState<string>(''); // 英文目录名
  const [nameEN, setNameEN] = useState<string>(dashboardName); // 中文目录名
  // 英文目录名错误信息
  const [nameENErr, setNameENErr] = useState<string>('');
  // 中文目录名错误信息
  const [nameCNErr, setNameCNErr] = useState('');
  // const NAME_REGEX = /^[\u4E00-\u9FA5a-zA-Z0-9 _\-()]+$/;
  // 检测英文目录名
  const checkNameEN: () => boolean = () => {
    // 目录名为空字符串的情况
    if (checkNameNull(nameEN)) {
      const errorTipsObj:any = {
        dashboard: 'dbl_menu_dashboard_name_null',
        folder: 'dbl_menu_folder_name_null',
        subfolder: 'dbl_menu_subfolder_name_null',
        menu: 'dbl_menu_menu_name_null',
      };
      // const errorTips = 'menu_dashboard_name_null';
      setNameENErr(formatMessage({id: errorTipsObj?.[type]}));
      return false;
    }

    if (nameEN?.replace(/\s/g, "")?.length > 50) {
      setNameENErr(formatMessage({id: 'dbl_menu_must_contain_less'}));
      return false;
    }

    if (!DASHBOARD_NAME_REGEX.test(nameEN)) {
      setNameENErr(formatMessage({id: 'dbl_common_dashboard_valid_name'}));
      return false;
    }

    setNameENErr('');
    return true;
  };

  // 检测中文目录名,中文目录名可以为空
  const checkNameCN: () => boolean = () => {
    if (nameCN && !DASHBOARD_NAME_REGEX.test(nameCN)) {
      setNameCNErr(formatMessage({id: 'dbl_common_dashboard_valid_name'}));
      return false;
    }

    if (nameCN?.replace(/\s/g, "")?.length > 50) {
      setNameCNErr(formatMessage({id: 'dbl_menu_must_contain_less'}));
      return false;
    }

    setNameCNErr('');
    return true;
  };

  return {
    nameCN,
    setNameCN,
    nameEN,
    setNameEN,
    nameENErr,
    setNameENErr,
    nameCNErr,
    setNameCNErr,
    checkNameEN,
    checkNameCN,
  };
};

export const useNull = (selectedLevel:string | undefined,nameEN:string,selectMenu:string|undefined,selectFolder:string|undefined) => {
  const isNull = useMemo(()=>!selectedLevel ||  !nameEN || !selectMenu || !selectFolder,[selectedLevel,nameEN,selectMenu,selectFolder]);
  return {
    isNull
  };
};
